import {
  ERROR_LOADING_PORTAL,
  GET_DATA_PORTAL,
  RESET_DATA_DETAIL_PORTAL,
  START_LOADING_PORTAL,
  STOP_LOADING_PORTAL,
} from "./action-types";
import initialState from "./initialState";

export const dataPortalDetailReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case START_LOADING_PORTAL:
      return {
        ...state,
        stateIs: "Pending",
      };

    case ERROR_LOADING_PORTAL:
      return {
        ...state,
        stateIs: "Error",
      };

    case STOP_LOADING_PORTAL:
      return {
        ...state,
        stateIs: "Idle",
      };
    case GET_DATA_PORTAL:
      return {
        ...state,
        data: action.payload,
        message: "",
        stateIs: "Idle",
      };

    case RESET_DATA_DETAIL_PORTAL: {
      return initialState;
    }
    default:
      return state;
  }
};
